import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
//port {Headers, Http, RequestOptions, Response} from '@angular/http';
import {catchError, map} from 'rxjs/operators';
import {Observable, throwError} from 'rxjs';

import {environment} from 'environment';
import {EventUserInfo} from './../models/user-info';
import {IEventRegistrationRepository} from './event-registration.repository.interface';

@Injectable()
export class EventRegistrationRepository implements IEventRegistrationRepository {

  constructor(private http: HttpClient) { }

  public register(userInfo: EventUserInfo): Observable<string> {
    const headers: HttpHeaders = new HttpHeaders();
    headers.append('Content-Type', 'application/json');

    return this.http.post<string>(`${environment.event_registration}/register`, userInfo, {headers: headers, withCredentials: true})
      .pipe(
//        map((response: Response) => response.json()),
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return an observable with a user-facing error message.
    return throwError(() => new Error('Something bad happened; please try again later.'));
  }
}
